import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ArrowNext } from '../index';
import { withStyles, MenuItem } from '@material-ui/core';
import styles from './styles';

const ParkingHour = ({ classes, t }) => {
  return (
    <React.Fragment>
      <MenuItem className={classes.wrapper}>
        <span className={classes.logo__container}>
          <span className={classes.price__logo}>{t('mp-information.label.price')}</span>
        </span>
        <span className={classes.title}>{t('mp-information.label.parking-hour')}</span>
        <ArrowNext classes={classes.arrow} />
      </MenuItem>
    </React.Fragment>
  );
};

ParkingHour.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(ParkingHour));
